// eslint-disable-next-line prettier/prettier
import { makeStyles } from '@material-ui/styles';
import { fontWeight } from '@mui/system';

export default makeStyles((theme) => ({
    card: {
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    tablecell: {
        fontSize: theme.palette.textSizeMedium
    },
    gridClass: {
        backgroundColor: 'white',
        border: '0px !important',
        margin: '10px 0px !important',
        height: '100%',
        width: '100%',
        fontSize: '13px !important',
        [theme.breakpoints.only('xs')]: {
            overflowX: 'visible'
        },
        '& .MuiDataGrid-row:first-child': {
            marginTop: '12px'
        }
    },
    respForm: {
        [theme.breakpoints.down('sm')]: {
            marginTop: '15px'
        }
    },
    visitsNumberContainer: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        paddingBottom: theme.spacing(1)
    },
    progressSection: {
        marginBottom: theme.spacing(1)
    },
    progressTitle: {
        marginBottom: theme.spacing(2)
    },
    progress: {
        marginBottom: theme.spacing(1),
        backgroundColor: 'rgb(236, 236, 236)'
    },
    pieChartLegendWrapper: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-end',
        marginRight: theme.spacing(1)
    },
    legendItemContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1)
    },
    fullHeightBody: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    tableWidget: {
        overflowX: 'auto'
    },
    progressBarPrimary: {
        backgroundColor: theme.palette.primary.main
    },
    progressBarWarning: {
        backgroundColor: theme.palette.warning.main
    },
    performanceLegendWrapper: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        marginBottom: theme.spacing(1)
    },
    legendElement: {
        display: 'flex',
        alignItems: 'center',
        marginRight: theme.spacing(2)
    },
    legendElementText: {
        marginLeft: theme.spacing(1)
    },
    serverOverviewElement: {
        display: 'flex',
        alignItems: 'center',
        maxWidth: '100%'
    },
    serverOverviewElementText: {
        minWidth: 145,
        paddingRight: theme.spacing(2)
    },
    serverOverviewElementChartWrapper: {
        width: '100%'
    },
    mainChartBody: {
        overflowX: 'auto'
    },
    mainChartHeader: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        [theme.breakpoints.only('xs')]: {
            flexWrap: 'wrap'
        }
    },
    mainChartHeaderLabels: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.only('xs')]: {
            order: 3,
            width: '100%',
            justifyContent: 'center',
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(2)
        }
    },
    mainChartHeaderLabel: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: theme.spacing(3)
    },
    mainChartSelectRoot: {
        borderColor: `${theme.palette.text.hint}80 !important`
    },
    mainChartSelect: {
        padding: 10,
        paddingRight: 25
    },
    mainChartLegentElement: {
        fontSize: '18px !important',
        marginLeft: theme.spacing(1)
    },
    success: {
        backgroundColor: theme.palette.success.main,
        color: '#fff'
    },
    warning: {
        backgroundColor: theme.palette.warning.main,
        color: '#fff'
    },
    secondary: {
        backgroundColor: theme.palette.secondary.main,
        color: '#fff'
    },
    mainHeadForm: {
        display: 'flex'
    },
    headContainer: {
        float: 'right',
        marginTop: '20px',
        marginRight: '100px',
        [theme.breakpoints.down('sm')]: {
            marginLeft: 'auto',
            marginRight: '5px'
        }
    },
    fieldPadding: {
        paddingRight: '95px !important',
        [theme.breakpoints.down('sm')]: {
            paddingRight: '18px !important'
        }
    },
    alignCenter: {
        justifyContent: 'center'
    },
    buttonMargin: {
        marginTop: '8px !important',
        [theme.breakpoints.down('xs')]: {
            marginTop: '0px !important',
            paddingBottom: '10px'
        }
    },
    formContainer: {
        margin: '25px 0px 20px 0px',
        borderRadius: '10px',
        border: '1px solid silver',
        padding: '13px 13px 43px 13px'
    },
    formAlign: {
        display: 'flex',
        width: 'auto',
        padding: '4px'
    },
    divAdjust: {
        width: '190%'
    },
    formAlignFirst: {
        width: 'auto'
    },
    inputHead: {
        marginLeft: '8px',
        fontSize: '13px',
        width: '84%',
        '& .MuiButton-root, & .MuiButton-root:hover': {
            backgroundColor: 'transparent',
            padding: '0px',
            height: '15px'
        }
    },
    heading: {
        color: 'black',
        padding: '8px',
        fontSize: '22px'
    },
    mainHeadInstance: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    iconAdjust: {
        marginLeft: '15px',
        display: 'flex',
        width: '25%'
    },
    textBox: {
        width: '100%'
    },
    iconButton: {
        display: 'flex'
    },
    secondHeadApi: {
        background: '#56C5FF1A',
        borderRadius: '5px',
        width: '90%',
        height: 'auto',
        padding: '0px 0px 13px 0px',
        marginTop: '0px !important',
        marginLeft: '8px !important',
        paddingBottom: '10px',
        paddingRight: '200px',
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            width: 'auto',
            height: 'auto',
            paddingRight: '10px',
            display: 'inline-block'
        },
        [theme.breakpoints.down('sm')]: {
            width: 'auto',
            height: 'auto',
            paddingRight: '10px'
        }
    },
    innerheadApi: {
        width: '270px',
        height: '32px',
        padding: '0.001rem',
        borderTopRightRadius: '5px',
        borderBottomRightRadius: '5px'
    },
    innerText: {
        marginTop: '13px',
        height: '19px',
        borderRadius: '0px 8px 8px 0px !important',
        fontWeight: 'bold'
    },
    nextSet: {
        display: 'flex',
        // marginLeft: '50px !important',
        [theme.breakpoints.down('xs')]: {
            margin: '10px 0px 0px 5px'
        }
    },
    formTextApi: {
        marginTop: '19px'
    },
    boxContainer: {
        margin: '18px 18px 8px 8px',
        borderRadius: '5px',
        border: '1px solid silver',
        paddingBottom: '10px'
    },
    boxSet: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: '20px',
        marginRight: '120px',
        [theme.breakpoints.only('xs')]: {
            marginRight: '0px'
        }
    },
    boxFlex: {
        display: 'flex',
        margin: '0px 4px 4px 4px'
    },
    customText: {
        maxHeight: '55%'
    },
    boxHead: {
        background: '#EDEFF1',
        borderRadius: '0px 8px 8px 0px !important',
        margin: '10px 20px 0 0'
    },
    formTextFirst: {
        marginTop: '10px',
        marginLeft: '10px',
        width: '30%',
        fontSize: '14px'
    },
    helperText: {
        marginLeft: '3px !important'
    },
    firstDaily: {
        marginLeft: '18px'
    },
    // firstDaily: {
    //     marginLeft: '18px'
    // },
    flexLast: {
        flexDirection: 'row',
        marginBottom: '20px',
        marginLeft: '10px',
        marginRight: '5px'
    },
    lastHeadtext: {
        marginLeft: '8px',
        textOverflow: 'ellipsis',
        width: 'auto',
        marginBottom: '0px !important',
        fontSize: theme.palette.textSizeLarge
    },
    buttonRemove: {
        display: 'flex',
        marginLeft: '4px',
        justifyContent: 'space-between',
        cursor: 'pointer'
    },
    buttonInnerRemove: {
        paddingRight: '3px',
        cursor: 'pointer'
    },
    endoreMent: {
        fontWeight: 'bold',
        fontSize: theme.palette.textSizeLarge
    },
    compCreate: {
        display: 'flex'
    },
    tableWrapper: {
        position: 'relative'
    },
    tableContentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        '& .MuiDataGrid-row > .MuiDataGrid-cell:nth-child(7)': {
            marginTop: '0'
        },
        '& .MuiDataGrid-row > .MuiDataGrid-cell:nth-child(8) div': {
            display: 'inherit'
        }
    },
    container: {
        margin: '15px 10px',
        [theme.breakpoints.down('xs')]: {
            margin: '15px 0px'
        }
    },
    cardTitle: {
        fontSize: theme.palette.textSizeMax,
        display: 'inline-block',
        paddingTop: '5px',
        fontWeight: 600,
        fontFamily: 'Lato sans-serif !important'
    },
    newInstancesButton: {
        '&:hover, &:focus': {
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: 'white !important'
        },
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        position: 'absolute',
        right: 0
    },
    containerCard: {
        padding: '20px 40px',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '12px !important',
        marginBottom: '30px',
        [theme.breakpoints.down('xs')]: {
            padding: '20px 20px'
        }
    },
    materailIcon: {
        display: 'flex',
        paddingLeft: `${theme.spacing(4)}px !important`,
        paddingRight: `${theme.spacing(4)}px !important`,
        color: theme.palette.text.secondary,
        fontSize: 24,
        overflowX: 'hidden'
    },
    updatedByText: {
        fontWeight: 600,
        fontSize: `${theme.palette.textSizeLarge} !important`
    },
    materialIconText: {
        marginLeft: theme.spacing(1),
        fontSize: `${theme.palette.textSizeLarge} !important`,
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    nameIcon: {
        marginTop: '3px',
        width: '14px !important',
        height: '14px !important'
    },
    editIcon: {
        width: '14px !important',
        height: '14px !important'
    },
    editButton: {
        marginRight: '20px'
    },
    actionButtonContainer: {
        paddingTop: '0px !important',
        marginTop: '-7px !important'
    },
    popupTitle: {
        fontSize: '16px !important',
        textAlign: 'center',
        padding: '30px 60px !important'
    },
    alignRight: {
        textAlign: 'right'
    },
    popupButtonGrid: {
        display: 'block',
        margin: 'auto'
    },
    pb30: {
        paddingBottom: '30px'
    },
    mx10: {
        '&:hover, &:focus': {
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: 'white !important'
        },
        color: `${theme.palette.primary.main} !important`,
        borderColor: `${theme.palette.primary.main} !important`,
        marginLeft: '10px',
        marginRight: '10px',
        textTransform: 'revert !important'
    },
    newChip: {
        color: `${theme.palette.primary.main} !important`,
        border: `1px solid ${theme.palette.primary.main} !important`,
        backgroundColor: '#FFF !important',
        marginLeft: '5px',
        marginTop: '3px',
        fontSize: `${theme.palette.textSizeSmall} !important`,
        height: '18px !important'
    },
    tableSearchIcon: {
        width: '12px !important',
        height: '12px !important'
    },
    searchTextField: {
        marginTop: theme.palette.textSizeExtraLarge
    },
    resize: {
        fontSize: `${theme.palette.textSizeLarge} !important`
    },
    customPagination: {
        '& .MuiPagination-root .MuiPagination-ul': {
            flexWrap: 'nowrap'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child svg, & .MuiPagination-root .MuiPagination-ul li:last-child svg':
            {
                display: 'none'
            },
        '& .MuiPagination-root .MuiPagination-ul li:last-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child > button, & .MuiPagination-root .MuiPagination-ul li:last-child > button::before':
            {
                margin: '0px 5px'
            }
    },
    showPaginationDesc: {
        float: 'left',
        position: 'absolute',
        left: '0px'
    },
    pageItem: {
        border: '1px solid #E9EBF0 !important',
        margin: '0px !important',
        borderRadius: '0px !important',
        height: '32px !important',
        '& button::after': {
            margin: '0px'
        }
    },
    buildButton: {
        color: '#65AAFC !important',
        width: '100px',
        margin: '10px auto !important',
        borderColor: '#65AAFC !important'
    },
    serviceGrid: {
        flexDirection: 'column !important',
        border: '1px solid #E8E8E8',
        borderRadius: '5px',
        width: '255px !important',
        padding: '15px'
    },
    allServicesGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        gridColumnGap: '30px',
        gridRowGap: '30px',
        padding: '10px 0px 10px 25px'
    },
    serviceInput: {
        marginTop: '10px !important',
        borderColor: '#D4D4D4',
        '& input.MuiOutlinedInput-input': {
            padding: '5px'
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D4D4D4'
        }
    },
    serviceName: {
        fontSize: '15px',
        color: '#4E4E4E',
        fontWeight: '600'
    },
    version: {
        color: '#596780',
        fontSize: '10px'
    },
    releaseToggle: {
        color: '#596780',
        fontSize: '13px',
        verticalAlign: 'top',
        float: 'right',
        '& svg': {
            verticalAlign: 'sub',
            height: '16px'
        }
    },
    buildDialogTitle: {
        padding: '20px 24px 0px !important',
        fontSize: '18px !important'
    },
    closeDialog: {
        position: 'absolute',
        margin: '20px',
        right: '0px'
    },
    buildButtonDiv: {
        display: 'flex',
        flexDirection: 'row',
        // position: 'relative',
        width: '100%',
        '& div': {
            display: 'flex',
            flexDirection: 'column',
            '& div': {
                position: 'absolute',
                top: '-4px'
            },
            '& svg': {
                marginRight: '5px',
                verticalAlign: 'top'
            },
            '& button': {
                padding: '0px',
                '&.MuiButton-root:hover': {
                    backgroundColor: 'transparent'
                }
            }
        }
    },
    btnStart: {
        '&.MuiButton-root:hover': {
            color: '#6C9CFA',
            backgroundColor: 'transparent'
        }
    },
    deploymentDetails: {
        '&>span': {
            width: 'inherit',
            margin: '0px',
            fontWeight: '600',
            height: '18px',
            '&>.MuiSwitch-root': {
                float: 'right',
                top: '-5px'
            },
            '&:nth-child(2)': {
                paddingTop: '3px'
            }
        }
    },
    g2Title: {
        fontSize: '18px',
        fontWeight: '600',
        padding: '10px 8px 6px 8px',
        marginLeft: '26px',
        marginRight: '26px'
    },
    g2Desc: {
        textAlign: 'center'
    },
    g2ButtonDiv: {
        textAlign: 'center',
        padding: '32px 0 16px 0'
    },
    g2ButtonEvent: {
        '&:hover, &:focus': {
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: 'white'
        },
        padding: '4px',
        borderRadius: '3px',
        border: '1px solid #5CBCFE',
        color: '#5CBCFE',
        '& span': {
            padding: '0 12px'
        }
    },
    g2ButtonCancel: {
        '&:hover, &:focus': {
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: 'white'
        },
        padding: '4px',
        borderRadius: '3px',
        border: '1px solid #5CBCFE',
        margin: '0 16px 0 0',
        color: '#5CBCFE',
        '& span': {
            padding: '0 12px'
        }
    }
}));
